import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { getMode, toggleMode } from '../lib/theme';
import { t } from '../lib/i18n';

// Light/dark switch. Flipping toggleMode() rewrites data-mms-mode on <html>, so
// every var(--mms-*) surface repaints via CSS; this button only re-renders its icon.
export default function ModeToggle() {
  const [mode, setMode] = useState(getMode());
  return (
    <button
      onClick={() => setMode(toggleMode())}
      title={mode === 'dark' ? t('Light mode') : t('Dark mode')}
      aria-label={t('Toggle dark mode')}
      className="flex h-[34px] w-[34px] items-center justify-center rounded-md border border-mms-border text-mms-muted hover:border-[var(--mms-hover-border)] hover:text-mms-text"
    >
      {mode === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
